import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { UpdateGridHeadersRequest } from "../../domain";
import { Observable } from "rxjs";
import { GridHeadersRepository } from "../../repositories";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";

@Injectable({ providedIn: 'root' })
export class UpdateGridHeadersUsecase implements UseCase<BaseRequest<UpdateGridHeadersRequest[]> | BaseRequest<UpdateGridHeadersRequest>, boolean> {

  constructor(private gridHeadersRepository: GridHeadersRepository) {
  }

  execute(params: BaseRequest<UpdateGridHeadersRequest[]> | BaseRequest<UpdateGridHeadersRequest>): Observable<boolean> {
    return this.gridHeadersRepository.updateGridHeaders(params);
  }

}
